import { render, staticRenderFns } from "./Echo.vue?vue&type=template&id=22d946bf"
import script from "./Echo.vue?vue&type=script&lang=js"
export * from "./Echo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports